import AuraWeb from "src/images/AuraWeb.png";
import FlushAccordian from "src/SharedComponents/FlushAccordian/FlushAccordian";
import { IAuraSoftwareSuiteLicensesInfo, IClinic, IUserLicencesInfo } from "src/Utils/Hooks/useGetDistributorInfo/useGetDistributorInfo";
import AuraAppLicensesAssigned from "./AuraAppLicensesAssigned/AuraAppLicensesAssigned";
import AuraAppLicensesUnassigned from "./AuraAppLicensesUnassigned/AuraAppLicensesUnassigned";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export interface IAuraAppLicenses{
    auraAppLicenses: IUserLicencesInfo[];
    clinics: IClinic[] | undefined;
    distributorId: string;
    otherLicenses: IAuraSoftwareSuiteLicensesInfo[];
}

const AuraAppLicenses: React.FC<IAuraAppLicenses> = ({auraAppLicenses, clinics, distributorId, otherLicenses}) => {
    const [assignedLicenses, setAssignedLicenses] = useState<IUserLicencesInfo[]>([]);
    const [unassignedLicenses, setUnassignedLicenses] = useState<IUserLicencesInfo[]>([]);
    const {t} = useTranslation();
    
    const getLicensesByClinic = useCallback((assignedToClinic: boolean) => {
        return auraAppLicenses && auraAppLicenses?.filter((license: IUserLicencesInfo) => license?.isAssignedToClinic === assignedToClinic);
    }, [auraAppLicenses]);

    useEffect(() => {
        var assignedlicenses = getLicensesByClinic(true);
        var unassignedlicenses = getLicensesByClinic(false);
        setAssignedLicenses(assignedlicenses);
        setUnassignedLicenses(unassignedlicenses);
    }, [getLicensesByClinic])

    return(
        <>
            <FlushAccordian title={t('AuraAppLicenses')} id="AuraAppLicenses" titleImage={AuraWeb} titleImageWidth="72px" marginRightImage="6px">
                <div className="pt-4">
                    {
                        assignedLicenses.length > 0 ? <AuraAppLicensesAssigned auraAppLicensesAssigned={assignedLicenses} distributorId={distributorId} otherLicenses={otherLicenses}/> : <></>
                    }
                    {
                        unassignedLicenses.length > 0 ? <AuraAppLicensesUnassigned auraAppLicensesUnassigned={unassignedLicenses} clinics={clinics} distributorId={distributorId}/> : <></>
                    }
                </div>
            </FlushAccordian>
        </>
    );
}

export default AuraAppLicenses;